export default {
  massEnable: 'Enable idle rules',
  massDisable: 'Disable idle rules',
};
